export function getOneBasedMonth(date: Date) {
	return date.getMonth() + 1;
}
